module.exports = __webpack_public_path__ + "static/media/edit.7bf6c436.svg";